import { HTTP_TOKEN_REPORT } from "./http";

export const getCostHistorys = (productId, params) => {
  return HTTP_TOKEN_REPORT.get(`product/${productId}/costhistory`, { params } ).then(result => {
    return result.data;
  });
};

export const createCostHistory = (productId, data) => {
  return HTTP_TOKEN_REPORT.post(`product/${productId}/costhistory`, data).then(result => {
    return result.data;
  });
};

export const updateCostHistory = (productId, costHistoryId, data) => {
  return HTTP_TOKEN_REPORT.put(`product/${productId}/costhistory/${costHistoryId}`, data).then(result => {
    return result.data;
  });
};

export const removeCostHistory = (productId, costHistoryId) => {
  return HTTP_TOKEN_REPORT.delete(`product/${productId}/costhistory/${costHistoryId}`).then(result => {
    return result.data;
  });
};
